//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userHeader from '~/components/login/userHeader.vue'
export default {
  components: {
    'user-header': userHeader
  },
  props: {
    phone: {
      type: [Number, String], default: '未传入手机号'
    },
    titStr: {
      type: Boolean, default: true
    },
    formatError: {
      type: String, default: ''
    },
    areaCode: {
      type: String, default: ''
    },
    userId: {
      type: String, default: ''
    }
  },
  data () {
    return {
      smsState: false, // 验证码样式
      smsCodeTxt: '', // 验证码绑定
      clearButton: false,
      graphicalImg: '' // 图形验证码图片
    }
  },
  watch: {
    smsCodeTxt (newV) {
      if (newV) this.clearButton = true
      else this.clearButton = false
    }
  },
  mounted () {
    this.graphical()
  },
  methods: {
    // 获取图形验证码
    async graphical () {
      try {
        const { succeed = false, extra = '', result = {} } = await this.$api.login.usergraphical({ areaCode: this.areaCode, userId: this.userId, phonenumber: this.phone, length: 4, width: 140, heigth: 40 })
        if (!succeed) return extra // 数据错误
        this.graphicalImg = result
      } catch (err) {}
    }
  }
}
